const myInterval = setInterval(myTimer, 2000);

function myTimer() {
  if(!document.querySelector('fw-embed-feed')) return;
  let showdowRootGrid = document.querySelector('fw-embed-feed').shadowRoot.querySelector('.fwn-grid'),
    thumbnailCaption = showdowRootGrid.querySelectorAll('.fw-thumbnail-caption');
    if(showdowRootGrid){
    clearInterval(myInterval);
     thumbnailCaption.forEach(function(ele){
        ele.style.fontWeight = '400';
     });
  } 
  
  let showdowRoot = document.querySelector('fw-storyblock').shadowRoot.querySelectorAll('[data-testid="storyblock"]');
  if(showdowRoot){
  clearInterval(myInterval);
   showdowRoot.forEach(function(ele) {
     ele.style.height = "100vh";
   });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const storyblockItem = document.querySelector('fw-storyblock');
  if (storyblockItem) {
    var storyblocks = storyblockItem.shadowRoot.querySelectorAll('[data-testid="storyblock"] video');
    if (storyblocks) {
      storyblocks.forEach(function(storyblock) {
        storyblock.style.objectFit = "unset";
      });
    }
  }
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

var giftNote = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.note-button');
    this.textarea = this.querySelector('textarea');
    this.form = this.querySelector('.note-form');


    this.setListeners();
  }

  setListeners() {
    // On button click
    this.button.addEventListener('click', this.onButtonClick.bind(this));
    
    // Update note in the cart
    this.textarea.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300)
    );
  }

  onButtonClick(event) {
    console.log(this.button.classList.contains('active'))
    if (this.button.classList.contains('active')) {
      this.button.classList.remove('active');
      slideUp(this.form, 300);
      
      this.clearNote();
    } else {
      this.button.classList.add('active');
      slideDown(this.form, 300);
    }
  }

  clearNote() {
    this.textarea.value = '';
    this.textarea.dispatchEvent(new Event('change'));
  }
}

customElements.define('cart-note', giftNote);